import { noAuthGetApi, noAuthPostApi, noAuthPutApi } from './apis';
const requestCache = new Map();

const cacheKey = (endpoint: string, params?: any) => {
  return `${endpoint}${params ? JSON.stringify(params) : ''}`;
};

const withCache = async (key: string, request: () => Promise<any>) => {
  if (requestCache.has(key)) {
    return requestCache.get(key);
  }

  const promise = request();
  requestCache.set(key, promise);

  try {
    const result = await promise;
    setTimeout(() => requestCache.delete(key), 2000);
    return result;
  } catch (error) {
    requestCache.delete(key);
    throw error;
  }
};

export const fetchCropYearDropdownData = async (type: string) => {
    let endpoint = "";

    switch (type) {
        case "cropYear":
            endpoint = "CropYear/GetCropYear";
            break;
        case "farmName":
            endpoint = "CropYear/GetFarmName";
            break;
        default:
            throw new Error("Invalid dropdown type");
    }

    return withCache(cacheKey(endpoint), async () => {
      try {
        return await noAuthGetApi(endpoint);
      } catch (error: unknown) {
        if (error instanceof Error) {
          throw new Error(`Failed to fetch data for ${type}: ${error.message}`);
        }
        throw new Error(`Failed to fetch data for ${type}: unknown error occurred`);
      }
    });
};

export const fetchCropYearFieldName = async (value: string, calyear: number) => {
    const endpoint=`CropYear/GetFieldName?Farm=${value}&CropYear=${calyear}`;
    
       return withCache(cacheKey(endpoint), async () => {
          try {
            return await noAuthGetApi(endpoint);
          } catch (error: unknown) {
            if (error instanceof Error) {
              throw new Error(`Failed to fetch data: ${error.message}`);
            }
            throw new Error('Failed to fetch data: unknown error occurred');
          }
        });
}

export const fetchCropYearDropdown = async (type: string, value: string): Promise<any> => {
    let endpoint = "";

    switch (type) {
        case "cropName":
            endpoint = `CropYear/GetCropYearCropName`;
            break;
        case "totalFarmAcres":
            endpoint = `CropYear/GetTotalFarmAcres?Field=${value}`;
            break;
        case "cropBegin":
            endpoint = `CropYear/GetCropYearBeginDate?CropYear=${value.split(',')[0]}&Farm=${value.split(',')[1]}&Field=${value.split(',')[2]}`;
            break;
        case "cropEnd":
            endpoint = `CropYear/GetCropYearEndDate?CropYear=${value.split(',')[0]}&Farm=${value.split(',')[1]}&Field=${value.split(',')[2]}`;
            break;

        default:
            throw new Error("Invalid dropdown type");
    }
      return withCache(cacheKey(endpoint), async () => {
        try {
          return await noAuthGetApi(endpoint);
        } catch (error: unknown) {
          if (error instanceof Error) {
            throw new Error(`Failed to fetch data for ${type}: ${error.message}`);
          }
          throw new Error(`Failed to fetch data for ${type}: unknown error occurred`);
        }
      });
}

export const postCropYearData = async (data: any) => {
    try {
        return await noAuthPostApi('CropYear/AddCropYearDataGridView', data);
    } catch (error: unknown) {
        if (error instanceof Error) {
            throw new Error(`Failed to fetch data : ${error.message}`);
        } else {
            throw new Error('Failed to fetch data : unknown error occured');
        }
    }
}

export const fetchCropYearGrid = async (value: number) => {
    const endpoint=`CropYear/GetCropYearDataBasedOnUserId?UserId=${value}`;
      return withCache(cacheKey(endpoint), async () => {
        try {
          return await noAuthGetApi(endpoint);
        } catch (error: unknown) {
          if (error instanceof Error) {
            throw new Error(`Failed to fetch data: ${error.message}`);
          }
          throw new Error('Failed to fetch data: unknown error occurred');
        }
      });
}

export const approveCropYearGridView = async (data: any) => {
    try {
        return await noAuthPostApi('CropYear/ApproveCropYearData', data);
    } catch (error: unknown) {
        if (error instanceof Error) {
            throw new Error(`Failed to fetch data : ${error.message}`);
        } else {
            throw new Error('Failed to fetch data : unknown error occured');
        }
    }
}

export const updateCropYearGridView = async (data: any) => {
    try {
        return await noAuthPutApi('CropYear/EditCropYearDataInGridView', data);
    } catch (error: unknown) {
        if (error instanceof Error) {
            throw new Error(`Failed to fetch data : ${error.message}`);
        } else {
            throw new Error('Failed to fetch data : unknown error occured');
        }
    }
}

export const deleteCropYearGridView = async (data: any) => {
    try {
        return await noAuthPutApi(`CropYear/DeleteCropYearDataInGridView?GridViewId=${data}`);
    } catch (error: unknown) {
        if (error instanceof Error) {
            throw new Error(`Failed to fetch data : ${error.message}`);
        } else {
            throw new Error('Failed to fetch data : unknown error occured');
        }
    }
}
export const fetchAllCropYearData = async (year:number) => {
  const endpoint=`CropYear/GetAllCropYearData?CropYear=${year}`;
      return withCache(cacheKey(endpoint), async () => {
        try {
          return await noAuthGetApi(endpoint);
        } catch (error: unknown) {
          if (error instanceof Error) {
            throw new Error(`Failed to fetch data: ${error.message}`);
          }
          throw new Error('Failed to fetch data: unknown error occurred');
        }
      })
}
export const bulkTransferCropYearGrid = async(data:any)=>{
  try {
      return await noAuthPostApi('CropYear/BulkTransferData',data);
  } catch (error: unknown) {
      if (error instanceof Error) {
          throw new Error(`Failed to fetch data : ${error.message}`);
      } else {
          throw new Error('Failed to fetch data : unknown error occured');
      }
  }
}